module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c2533b932cfc2d25008e404315dbe1e2.png";